
namespace q {

    export function getInstanceType(instance: any): any {
        if (instance == null)
            throw new Q.NullReferenceException('Cannot get type of null');

        // Have to catch as constructor cannot be looked up on native COM objects
        try {
            return instance.constructor;
        }
        catch (ex) {
            return Object;
        }
    };
    export function text(key: string, fallback: string): string {
        var result = Q.text(key);

        if (result == key) return fallback;
        else return result;
    }

    export function isCosmicThemeApplied(): boolean {
        return document.body.className.indexOf('cosmic') >= 0;
    }

    export function getSelectedLanguage(): string {
        var lang = (document.getElementById('LanguageSelect') as HTMLSelectElement).value || document.getElementsByTagName('html')[0].getAttribute('lang');
        return lang;
    }

    export function formatDecimal(value) {
        let title = Serenity.NumberFormatter.format(value, '#,##0.00');
        return title;
    }

    export function formatAmount(value, cultureName: string = 'en-IN', currencyName: string = 'INR') {
        var formatter = new Intl.NumberFormat(cultureName, {
            style: 'currency',
            currency: currencyName,
            minimumFractionDigits: 2,
        });

        var Value = formatter.format(Number(value));
        return Value;
    }

    export function formatInt(value) {
        let title = Serenity.NumberFormatter.format(value, '#,##0');
        return title;
    }

    // Check numeric or not then return value, if NAN then return zero(0)
    export function ToNumber(value): number {
        return isNaN(value) ? 0 : value;
    }

    export function ToFixed(value, fractionDigits = 2): string {
        return ToNumber(value).toFixed(fractionDigits);
    }

    

    export function ToBool(value) {
        let val: boolean = false;
        if (value == 'true' || value == 'True')
            val = true;

        return value == 'true' || value == 'True' ? true : false;
    }

    //colorDepth should be within '0123456789ABCDEF'
    export function getRandomColor(hexLetters) {
        var letters = hexLetters// '0123456789ABCDEF';

        var color = '#';
        for (var i = 0; i < 6; i++) {
            var letterIndex = Math.floor((Math.random()) * letters.length);
            if (letterIndex > 15) letterIndex = 15;
            if (letterIndex < 0) letterIndex = 0;
            color += letters[letterIndex];
        }
        return color;
    }

    export function Warning(title: string = 'Are you sure?', text: string, CancelButton: boolean = false) {
        Swal.fire({
            title: title,
            text: text,
            icon: 'warning',
            showCancelButton: CancelButton,
            //confirmButtonColor: '#3085d6',
            //cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        })
    }

    export function Alert(title: string = 'Are you sure?', text: string, timer: number = 2500, CloseButton: boolean) {
        Swal.fire({
            title: title,
            text: text,
            icon: 'warning',
            timer: timer,
            showCloseButton: CloseButton,
            showConfirmButton: CloseButton
        })
    }

    export function success(title: string = 'Are you sure?', text: string, timer: number = 2500, CloseButton: boolean) {
        Swal.fire({
            title: title,
            text: text,
            icon: 'success',
            timer: timer,
            showCloseButton: CloseButton,
            showConfirmButton: CloseButton
        })
    }

    export function alert(title: string = 'Are you sure?', text: string, CloseButton: boolean, timer: number = 2500) {
        Swal.fire({
            title: title,
            text: text,
            icon: 'error',
            timer: timer,
            showCloseButton: CloseButton,
            showConfirmButton: false
        })
    }


    export function information(title: string = 'Are you sure?', text: string, CancelButton: boolean = true, onOk: () => void,onCancel:()=>void) {
        Swal.fire({
            title: title,
            text: text,
            icon: 'warning',
            showCancelButton: CancelButton,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                onOk();
            } else {
                onCancel();
            }
        })
    }

    export function Authorize(title: string = 'Are you sure?', text: string, CancelButton: boolean = false) {

        var IsAuthorized: boolean = false;

        Swal.fire({
            title: title,
            text: text,
            icon: 'warning',
            showCancelButton: CancelButton,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Authorization',
                    html: `<input type="text" id="login" class="swal2-input" placeholder="Username">
  <input type="password" id="password" class="swal2-input" placeholder="Password">`,
                    confirmButtonText: 'Authorize',
                    focusConfirm: false,
                    preConfirm: () => {
                        const login = (document.getElementById('login') as HTMLInputElement).value
                        const password = (document.getElementById('password') as HTMLInputElement).value
                        if (!login || !password) {
                            Swal.showValidationMessage('Please enter login and password')
                        }
                        return { login: login, password: password }
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        var T = result.value.login;
                        Swal.fire(`Login: ${result.value.login}  Password: ${result.value.password}`.trim())

                        IsAuthorized = true;
                    }
                    
                })
            }
        })

        return IsAuthorized;
    }


    export function randomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    export function randomElem(arr) {
        return arr[randomInt(0, arr.length - 1)];
    }

    export function charset(name) {
        var charsets = {
            numbers: "0123456789",
            alphabetic: "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ",
            alphanumeric: "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
        };
        return charsets[name];
    }

    export function repeat(str, count) {
        var res = "";
        for (var i = 0; i < count; i++) {
            res += str;
        }
        return res;
    }


    export var Config: VoucherCodeConfig = {
        count: 1,
        length: 8,
        charset: "numbers",
        prefix: "",
        postfix: "",
        pattern: ""
    };

    export function generateOne(config) {
        var code = config.pattern.split('').map(function (char) {
            if (char === '#') {
                return randomElem(config.charset);
            } else {
                return char;
            }
        }).join('');
        return config.prefix + code + config.postfix;
    }

    export function isFeasible(charset, pattern, count) {
        return Math.pow(charset.length, (pattern.match(/#/g) || []).length) >= count;
    }

    export function CodeGenerate(config) {
        var count = config.count;
        if (!isFeasible(config.charset, config.pattern, config.count)) {
            throw new Error("Not possible to generate requested number of codes.");
        }

        var codes = {};
        while (count > 0) {
            var code = generateOne(config);
            if (codes[code] === undefined) {
                codes[code] = true;
                count--;
            }
        }
        return Object.keys(codes);
    }

}

